module.exports = __webpack_public_path__ + "static/img/brees-2005-slide-4.9d95d9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-slide-4.jpg
// module id = 3coH
// module chunks = 1